"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = OutsideAlerter;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _jsxRuntime = require("react/jsx-runtime");
var Block = _styledComponents.default.div.withConfig({
  displayName: "OutsideAlerter__Block",
  componentId: "sc-1w68hw1-0"
})(["width:100%;height:100%;display:block;"]);

/**
 * Hook that alerts clicks outside of the passed ref
 */
function useOutsideAlerter(ref, callback) {
  var enabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  (0, _react.useEffect)(function () {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target) && enabled) {
        callback(event);
      }
    }
    // Bind the event listener
    document.addEventListener('mouseup', handleClickOutside);
    return function () {
      // Unbind the event listener on clean up
      document.removeEventListener('mouseup', handleClickOutside);
    };
  }, [ref, callback, enabled]);
}

/**
 * Component that alerts if you click outside of it
 */
function OutsideAlerter(props) {
  var wrapperRef = (0, _react.useRef)(null);
  useOutsideAlerter(wrapperRef, props.callback, props.enabled);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Block, {
    ref: wrapperRef,
    children: props.children
  });
}
OutsideAlerter.defaultProps = {
  callback: function callback(_callback) {
    return _callback;
  }
};